var _rect, _rect2, _rect3, _rect4, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.0742,
    y: 0.80957,
    width: 44.9085,
    height: 44.9085,
    rx: 9.60006,
    transform: "rotate(12 16.0742 0.80957)",
    fill: "#077882",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.300001,
    y: 14.5822,
    width: 44.3085,
    height: 44.3085,
    rx: 9.30006,
    fill: "white",
    fillOpacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.300001,
    y: 14.5822,
    width: 44.3085,
    height: 44.3085,
    rx: 9.30006,
    stroke: "#D9D9D9",
    strokeWidth: 0.600002
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4004,
    y: 25.7998,
    width: 21.6001,
    height: 21.6001,
    rx: 3.60001,
    stroke: "#077882",
    strokeWidth: 1.50001
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2012 32.6826L25.5853 35.2985M28.2012 35.2985L25.5853 32.6826M18.8171 32.6826L16.2012 35.2985M18.8171 35.2985L16.2012 32.6826M19.6169 40.5174C21.0442 39.0902 23.3582 39.0902 24.7854 40.5174",
    stroke: "#077882",
    strokeWidth: 1.50001,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.167eeb2010f28a299fb4d64911dcc559.svg";
export { ForwardRef as ReactComponent };